import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import PublicViewPreviewContent from "./PublicViewPreviewContent";
import {
  FONT_AWESOME_URL,
  PUBLIC_VIEW_STYLES_URL,
  readHostCssVars,
} from "./publicViewThemeUtils";

export default function PublicViewPreview({
  auctionDetail,
  themeVars = {},
  onCssVarsReady,
}) {
  const hostRef = useRef(null);
  const mountRef = useRef(null);
  const cssVarsNotifiedRef = useRef(false);

  useEffect(() => {
    const host = hostRef.current;

    if (!host || host.shadowRoot) return;

    const shadowRoot = host.attachShadow({
      mode: "open",
    });

    const stylesLink = document.createElement("link");
    stylesLink.rel = "stylesheet";
    stylesLink.href = PUBLIC_VIEW_STYLES_URL;

    const notifyCssVars = () => {
      if (cssVarsNotifiedRef.current || !onCssVarsReady) return;
      cssVarsNotifiedRef.current = true;

      requestAnimationFrame(() => {
        onCssVarsReady(readHostCssVars(host));
      });
    };

    stylesLink.addEventListener("load", notifyCssVars);
    stylesLink.addEventListener("error", () => {
      console.error("Failed to load public view stylesheet");
    });
    shadowRoot.appendChild(stylesLink);

    const faLink = document.createElement("link");
    faLink.rel = "stylesheet";
    faLink.href = FONT_AWESOME_URL;
    shadowRoot.appendChild(faLink);

    const mountPoint = document.createElement("div");
    mountPoint.classList.add("cuspre", "body");
    shadowRoot.appendChild(mountPoint);
    mountRef.current = mountPoint;

    ReactDOM.render(
      <PublicViewPreviewContent auctionDetail={auctionDetail} />,
      mountPoint,
    );

    if (stylesLink.sheet) {
      notifyCssVars();
    }
  }, [onCssVarsReady]);

  useEffect(() => {
    const mount = mountRef.current;
    if (!mount) return;

    ReactDOM.render(
      <PublicViewPreviewContent auctionDetail={auctionDetail} />,
      mount,
    );
  }, [auctionDetail]);

  useEffect(() => {
    const host = hostRef.current;
    if (!host) return;

    Object.entries(themeVars).forEach(([cssVar, value]) => {
      if (value) host.style.setProperty(cssVar, value);
    });
  }, [themeVars]);

  useEffect(() => {
    const host = hostRef.current;
    if (!host?.shadowRoot) return;

    const name = auctionDetail?.detail?.auctionname;
    if (name) {
      const h1 = host.shadowRoot.querySelector(
        ".player-section .section-header h1",
      );
      if (h1) h1.textContent = name;
    }

    const logoPath =
      auctionDetail?.path && auctionDetail?.detail?.logo
        ? auctionDetail.path + auctionDetail.detail.logo
        : null;
    if (logoPath) {
      const leagueImg = host.shadowRoot.querySelector(
        ".player-section .league-logo img",
      );
      if (leagueImg) leagueImg.setAttribute("src", logoPath);
    }

    if (auctionDetail?.spn?.[0]?.logo && auctionDetail?.fpath) {
      const spnImg = host.shadowRoot.querySelector(
        ".player-section .sponsor-logo img",
      );
      if (spnImg)
        spnImg.setAttribute(
          "src",
          auctionDetail.fpath + auctionDetail.spn[0].logo,
        );
    }
  }, [auctionDetail]);

  return <div className="custom_preview" ref={hostRef}></div>;
}
